// App Store / Play Store links for each Zyppys app.
// Used by the download buttons; pass the right set per page.

export const CUSTOMER_APP = {
    ios: 'https://apps.apple.com/us/app/zyppys/id1157856133',
    android: 'https://play.google.com/store/apps/details?id=com.zyppys.customer&hl=en_IN',
};

export const BUSINESS_APP = {
    ios: 'https://apps.apple.com/in/app/zyppys-business/id6760188834',
    android: 'https://play.google.com/store/apps/details?id=com.doctorite.zyppysbusinessapp&hl=en_IN',
};

export const PARTNERS_APP = {
    ios: 'https://apps.apple.com/in/app/zyppys-partners/id6762341454',
    android: 'https://play.google.com/store/apps/details?id=com.doctorite.zyppyspartnerapp',
};
